import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import styled from 'styled-components'
// Mui
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
// Components
import { Layout } from '../components'

const MyPage = () => {

    const dispatch = useDispatch()

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign: 'center'}}>マイページ</h1>
            <div className='spacer-50' />

            <ListWrapper>
                <Divider />
                <ListItem button onClick={() => dispatch(push('/order/history'))}>
                    <ListItemText primary="購入履歴" />
                </ListItem>
                <Divider />
                <ListItem button onClick={() => dispatch(push('/profile'))}>
                    <ListItemText primary="アカウント情報" />
                </ListItem>
                <Divider />
                <ListItem button onClick={() => dispatch(push('/payment/edit'))}>
                    <ListItemText primary="クレジットカード情報" />
                </ListItem>
                <Divider />
                <ListItem button onClick={() => dispatch(push('/subscription'))}>
                    <ListItemText primary="メールマガジン配信設定" />
                </ListItem>
                <Divider />
                <ListItem button onClick={() => dispatch(push('/emailchange'))}>
                    <ListItemText primary="メールアドレス変更" />
                </ListItem>
                <Divider />
                <ListItem button onClick={() => dispatch(push('/passwordchange'))}>
                    <ListItemText primary="パスワード変更" />
                </ListItem>
                <Divider />
                <ListItem button onClick={() => dispatch(push('/delete'))}>
                    <ListItemText primary="退会" />
                </ListItem>
                <Divider />
            </ListWrapper>
            <div className='spacer-100' />
        </Layout>
    )
}
export default MyPage

const ListWrapper = styled(List)`
    width: 480px;
    margin: 0 auto !important;
    @media screen and (max-width:768px){
        width: 100%;
    }
`